import { render, staticRenderFns } from "./UserInvite.vue?vue&type=template&id=3f50f0ea"
import script from "./UserInvite.vue?vue&type=script&lang=js"
export * from "./UserInvite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports